import { useContext } from "react";
import { useQueryClient } from "react-query";

import { ReservationBrowsingPeriod, Mode } from "models/Mode";
import { TableStatus } from "models/Table";

import { ReservationsContext } from "../Reservations";

interface UseTopControlsReturn {
    handleModeChange: (modeToBeSet: Mode, browsingPeriod?: ReservationBrowsingPeriod) => void
}


export function useTopControls(): UseTopControlsReturn {
    const queryClient = useQueryClient();
    const {
        reservationsControl: {
            browsingPeriod,
            isFormDirty,
            mode,
            onBrowsingPeriodChange,
            onExitFormWarningChange,
            onModeChange,
            onPreviousModeChange,
            onReservationIdChange,
            onTablesStateChange,
            tablesState,
        },
    } = useContext(ReservationsContext);

    function clearMap(previousMode: Mode, modeToBeSet: Mode): void {
        onTablesStateChange(tablesState?.map(tableState => ({ ...tableState, reservations: modeToBeSet === Mode.PRINTING && previousMode === Mode.RESERVATION_BROWSING ? tableState.reservations : [], status: TableStatus.AVAILABLE })) ?? []);
    }

    function handleModeChange(newMode: Mode, newBrowsingPeriod: ReservationBrowsingPeriod = browsingPeriod): void {
        console.log("handleModeChange", newMode, newBrowsingPeriod);

        onPreviousModeChange(mode);

        if (newMode === Mode.RESERVATION_BROWSING) {
            onBrowsingPeriodChange(newBrowsingPeriod);
        }

        if (isFormDirty && [ Mode.RESERVATION_CREATION, Mode.RESERVATION_EDIT, Mode.DAILY_MESSAGE_EDIT ].some(m => m === mode)) {
            return onExitFormWarningChange({ modeToBeSet: newMode, show: true });
        }

        if (newMode !== Mode.DAILY_MESSAGE_EDIT) {
            clearMap(mode, newMode);
        } else {
            queryClient.removeQueries({ queryKey: "tables" });
        }

        onModeChange(newMode);

        switch (mode) {
            case Mode.RESERVATION_BROWSING:
            case Mode.DAILY_MESSAGE_EDIT:
            case Mode.PRINTING:
            case Mode.REPORT:
            case Mode.SEARCHING:
                onReservationIdChange({ id: undefined, shouldRefetch: false });
                break;

            default:
                break;
        }
    }

    return { handleModeChange };
}
